export const state = {
  azoliSalarie: undefined,
  azoliSalaries: []
}